import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@g2u/ui-kit';
import { useNavigate } from 'react-router';
import { JsonDataItem, type WithOptionalDataTest } from 'types';
import { CustomerSearchModal } from 'components';

type Props = {
  isOpen: boolean;
  callbackId: number;
  page?: number;
  onFinish: () => void;
  onLink: (payload: JsonDataItem) => void;
} & WithOptionalDataTest;

export const LinkCallbackModal: FC<Props> = observer((props) => {
  const { isOpen, callbackId, onFinish, onLink, page } = props;
  const navigate = useNavigate();

  return (
    <CustomerSearchModal
      customer={null}
      isOpen={isOpen}
      modalTitle={'Link to Customer'}
      actions={[
        {
          title: 'Link Customer',
          action: (record: any) => {
            onLink({ customerId: record.ID });
            onFinish();
          },
        },
      ]}
      onOk={() => {
        onFinish();
      }}
      onCancel={() => {
        onFinish();
      }}
      emptyContent={(formData: JsonDataItem) => {
        return (
          <Button.$
            type={Button.Type.Primary}
            onClick={() => {
              navigate('/customer/create', {
                state: { callbackId, page, formData },
              });
            }}
            dataTestId="new-customer-profile-btn"
          >
            Create new customer file
          </Button.$>
        );
      }}
    />
  );
});
